import {TFunction} from 'i18next';
import {ExportCarePlanData} from '../../base/export-care-plan-types';
import {CommonBadlPdfDataProcessor} from '../export-care-plan-common-badl-pdf-data';

export class PositionMobilityPdfDataProcessor extends CommonBadlPdfDataProcessor {
  // Inherits the same headers and row structure as Common processor.

  constructor(baseData: ExportCarePlanData, t: TFunction) {
    super(baseData, t);

    this.handleTaskDetailsCellValue = (entry) => {
      // TODO: hardcoded id. Feature flag missing.
      const positionEntry = entry.getEntryById('64a75b51b67f03ded5309993');
      const mobilityEntry = entry.getEntryById('698c6824f5aabb0d32d2e90c');

      if (mobilityEntry) {
        const mobilityName = `<b>${mobilityEntry?.name ?? 'n/a'}:</b>`;
        const mobilityValue = this.getEntryValue(mobilityEntry);

        return `${mobilityName}\n${mobilityValue}`;
      }

      const positionName = `<b>${positionEntry?.name ?? 'n/a'}:</b>`;
      const positionValue = this.getEntryValue(positionEntry);

      return `${positionName}\n${positionValue}`;
    };
  }
}
